import axios from 'axios';
import _ from 'lodash';
import collapsible from '../../../../scripts/modules/collapsible';
import breakpoints from '../../../../scripts/utilities/breakpoints';
import utility from '../utility';
import template from './template';
import gallery from './gallery';
import modal from '../../../modal/scripts';
import {body} from './constants';

const populate = ( id, content ) => {
	axios.get(utility.query.single(id))
	.then((response) => content.innerHTML = template(response.data))
	.catch((error) => console.log(error));
}

const mount = (content, id) => {
	populate(id, content);
}

const open = (parent, id) => {
	let content = document.getElementById('modal-' + id);
	if ( content.innerHTML === ' ' || content.innerHTML === '' ) mount(content, id);
	body.classList.add('is-active-modal');
	parent.setAttribute('data-active', id);
	parent.style.display = 'block';
	content.style.display = 'block';
	parent.onclick = (e) => {
		if (e.target.classList.contains('modal__wrapper') || e.target.id === 'modal-close') {
			close(parent, id);
		}
	}
	gallery(id);
	// Give it time to load.
	// Hacky, but it works.
	_.delay( () => {
		collapsible();
		modal();
	}, 1000);
}

const close = (parent, id) => {
	let content = document.getElementById('modal-' + id);
	body.classList.remove('is-active-modal');
	parent.setAttribute('data-active', 'none');
	parent.style.display = 'none';
	content.style.display = 'none';
	if ( breakpoints.get() === 'sm' ) {
		document.location = '#listing-' + id; // Scroll to the clicked listing.
	}
}

const create = (parent, id) => {
	let html = `<div id="modal-${id}" class="modal__content" style="display:none"></div>`;
	parent.querySelector('.modal__inner').innerHTML += html;
}

export default function ( className ) {
	let parent = document.getElementById('modal-listings');
	let collection = document.querySelectorAll(className);
	collection.forEach( (item) => {
		let id = item.id.split("-")[1];
		let listing = document.getElementById('listing-' + id);
		create(parent, id);
		listing.onclick = () => open(parent, id);
	});
}
